import * as React from "react";
import { useCallback, useEffect } from "react";
import { ProfilesHeaderView } from "./header/ProfilesHeaderView";
import "./profilesViewStyles.css";
import { useFocusable } from "../../../utils/Helpers";
import { focusManager } from "../../../utils/Focus";
import { updateChosenProfile } from "../../../services/user.service";
import { useAuth } from "../../../context/Auth";
import { useRouter } from "../../../context/Router";
export var ProfilesView = function (_a) {
    var t = _a.t, profiles = _a.profiles, userName = _a.userName, userMail = _a.userMail, handleLogOut = _a.handleLogOut, selectedProfile = _a.selectedProfile;
    useEffect(function () {
        focusManager.registerGroup({ name: "logout", position: 10 });
        focusManager.registerGroup({ name: "profile", position: 20 });
        focusManager.manualFocus("profile", 0);
    }, [focusManager]);
    return (React.createElement("div", { className: "screen-container profiles-screen" },
        React.createElement(ProfilesHeaderView, { t: t, userName: userName, userMail: userMail, handleLogOut: handleLogOut }),
        React.createElement("div", { className: "section-container" },
            React.createElement("div", { className: "section-content" },
                React.createElement("p", { className: "section-title" }, t("profile.choose_title")),
                React.createElement("div", { id: "profiles", className: "profile-items" }, profiles &&
                    profiles.map(function (profile, i) { return (React.createElement(ProfileItemView, { key: i, profile: profile, index: i, selectedProfile: selectedProfile })); }))))));
};
var ProfileItemView = function (_a) {
    var profile = _a.profile, index = _a.index, selectedProfile = _a.selectedProfile;
    var dispatch = useAuth().dispatch;
    var navigate = useRouter().navigate;
    var selectProfile = useCallback(function () {
        if (profile && profile.id) {
            updateChosenProfile(profile.id).then(function () {
                dispatch({ type: "SET_PROFILE", profile: profile });
                navigate("home");
            });
        }
    }, []);
    var ref = useFocusable({
        group: "profile",
        index: index,
        onKeyDown: selectProfile,
    });
    return (React.createElement("div", { className: "profile-item-container" },
        React.createElement("div", { ref: ref, tabIndex: 0, className: "profile-item " + (selectedProfile && selectedProfile.id === profile.id
                ? "selected-profile"
                : "") }, profile.forKids ? React.createElement("div", { className: "kids-icon" }) : null),
        React.createElement("p", { className: "profile-name" }, profile.name)));
};



//////////////////
// WEBPACK FOOTER
// ./src/components/views/profiles/ProfilesView.tsx
// module id = 153
// module chunks = 1